import { render, staticRenderFns } from "./StudentEnrollFilters.vue?vue&type=template&id=04851572&scoped=true&"
import script from "./StudentEnrollFilters.vue?vue&type=script&lang=js&"
export * from "./StudentEnrollFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04851572",
  null
  
)

export default component.exports